import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';

export const UploadDate = ({ date }) => {
  const { t } = useTranslation();
  const dateDisplay = date ? format(date, t('formats:datetime')) : '';

  return (
    date && (
      <span
        data-e2e="video-upload-date"
        className="ct-video-metadata__li ct-video-metadata__icon ct-video-metadata__icon--calendar"
        data-tooltip-content={`${t('display_date')}: ${dateDisplay}`}
        data-tooltip-id="videoMetadataTooltip"
        data-delay-show={1000}
      >
        <FontAwesomeIcon className="video-metadata-icon" icon={faCalendarAlt} />
        {dateDisplay}
      </span>
    )
  );
};
